import styled from 'styled-components';

import { Typography } from '@/components/Typography';

export const NameContainer = styled.div`
  max-height: 38px
  overflow: hidden;
`;
export const Name = styled(Typography)`
  text-transform: uppercase;
  text-align: center;
  min-height: 40px;
  font-size: ${({ theme }) => theme.fontSizes.p1};
  line-height: ${({ theme }) => theme.lineHeights.productName};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-family: ${({ theme }) => theme.fontFamilies.italianPlate};
  color: ${({ theme }) => theme.colors.secondary};
  padding-left: ${({ theme }) => theme.spacing(2)};
  padding-right: ${({ theme }) => theme.spacing(2)};

  @supports (-webkit-line-clamp: 2) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    -webkit-align-content: center;
    align-items: center;
    justify-content: center;
  }
  display: flex;
  align-items: center;
  justify-content: center;
`;
